export interface EditResponseError {
  status: number;
}

export interface EditResponseSuccess {
  status: {
    mid: string;
    subject: string;
    message: string;
  };
}

export enum ErrorStatus {
  NoExist = -1,
  NoEdit = -2,
  AlreadyReplied,
}
